(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo/assets/javascripts/marionette/nyxcontroller.js') >= 0) return;  svs.modules.push('/modules/bingo/assets/javascripts/marionette/nyxcontroller.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.bingo.nyx.Controller = Marionette.MnObject.extend({

    activeGames: undefined,

    initialize: function() {
      var self = this,
        loginParams = {
          operator: 'SvSpel',
          partner: 'Svspel'
        };

      this.nyx = window.nyxClient;
      if (!this.nyx) {
        return;
      }

      this.nyx.init(function() {
        self.nyxResponse.apply(self, arguments);
      }, loginParams);

      svs.bingo.nyxChannel.reply(
        {
          activeGames: this.getGames
        },
        this
      );
    },

    nyxResponse: function(queryName, result) {
      this.triggerMethod(queryName, result);
      svs.bingo.nyxChannel.trigger(queryName, result);
    },

    onGetGamesResult: function(result) {
      this.activeGames.resolve(result);
    },

    getGames: function() {
      this.activeGames = $.Deferred();

      this.nyx.trigger('ticketGetGames', { subsystem: 'bingo' });
      return this.activeGames.promise();
    }
  });
})(Backbone, _, svs);


 })(window);